import React, {
  useEffect,
  useState
} from 'react';

import {
  fetchShowings
} from '../../services/userService';

function ShowingsPanel() {

  const [showings, setShowings] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {

    loadShowings();

  }, []);

  const loadShowings = async () => {

    try {

      const data =
        await fetchShowings();

      setShowings(data);

    } catch (error) {

    } finally {

      setLoading(false);
    }
  };

  if (loading) {

    return <div>Loading...</div>;
  }

  return (
    <div>

      <h2>
        بازدیدها
      </h2>

      {showings.map((item) => (

        <div
          key={item.id}
          className="showing-card"
        >

          <h4>
            {item.property_title}
          </h4>

          <p>
            {item.visit_date}
          </p>

        </div>

      ))}

    </div>
  );
}

export default ShowingsPanel;